import styled from 'styled-components'
import { SPACING, BORDER_RADIUS, COLORS, TYPOGRAPHY, FONT_WEIGHT } from '../../styles/theme'

export const BuilderPage = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: ${SPACING.xl};
  color: var(--color-text-primary);
`

export const BuilderContent = styled.div`
  width: 100%;
  max-width: 960px;
  display: flex;
  flex-direction: column;
  gap: 0;
`

export const HeaderLeft = styled.div`
  display: flex;
  align-items: flex-start;
  gap: ${SPACING.sm};
  flex: 1;
  min-width: 0;
`

export const HeaderMeta = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${SPACING.xs};
`

export const PageBrandLabel = styled.div`
  display: flex;
  align-items: center;
  gap: ${SPACING.xs};
  font-size: ${TYPOGRAPHY.caption.fontSize};
  color: var(--color-text-tertiary);
`

export const MetaFields = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${SPACING.xs};
  margin-top: ${SPACING.xs};
`

export const MetaNameInput = styled.input`
  font-size: ${TYPOGRAPHY.h4.fontSize};
  font-weight: ${FONT_WEIGHT.bold};
  color: var(--color-text-primary);
  background: transparent;
  border: none;
  border-bottom: 1px solid transparent;
  outline: none;
  padding: 0;
  width: 100%;
  line-height: 1.3;
  transition: border-color 0.15s ease;

  &:hover,
  &:focus {
    border-bottom-color: var(--color-border-dark);
  }

  &::placeholder {
    color: var(--color-text-tertiary);
    font-weight: ${FONT_WEIGHT.medium};
  }
`

export const MetaDescriptionInput = styled.textarea`
  font-size: ${TYPOGRAPHY.caption.fontSize};
  color: var(--color-text-secondary);
  background: transparent;
  border: none;
  border-bottom: 1px solid transparent;
  outline: none;
  padding: 0;
  width: 100%;
  resize: none;
  line-height: 1.5;
  font-family: inherit;
  transition: border-color 0.15s ease;
  overflow: hidden;

  &:hover,
  &:focus {
    border-bottom-color: var(--color-border-dark);
  }

  &::placeholder {
    color: var(--color-text-tertiary);
  }
`

export const HeaderRight = styled.div`
  display: flex;
  align-items: center;
  gap: ${SPACING.sm};
  flex-shrink: 0;
  margin-top: 4px;
`

export const SaveIndicator = styled.span`
  font-size: ${TYPOGRAPHY.caption.fontSize};
  color: var(--color-text-tertiary);
`

export const RecordButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: ${SPACING.xs};
  padding: 7px ${SPACING.md};
  border-radius: ${BORDER_RADIUS.lg};
  border: 1px solid var(--color-border);
  background: transparent;
  color: var(--color-text-secondary);
  font-size: ${TYPOGRAPHY.caption.fontSize};
  font-weight: ${FONT_WEIGHT.medium};
  cursor: pointer;
  transition:
    color 0.15s ease,
    border-color 0.15s ease;

  &:hover {
    color: ${COLORS.primary};
    border-color: ${COLORS.primary};
  }
`

export const QuestionList = styled.div`
  display: flex;
  flex-direction: column;
`

export const AddQuestionButton = styled.button`
  width: 100%;
  height: 44px;
  border-radius: ${BORDER_RADIUS.xl};
  border: 1px dashed var(--color-border-dark);
  background: transparent;
  color: var(--color-text-tertiary);
  font-size: ${TYPOGRAPHY.caption.fontSize};
  font-weight: ${FONT_WEIGHT.medium};
  cursor: pointer;
  margin-top: ${SPACING.sm};
  transition:
    color 0.15s ease,
    border-color 0.15s ease;

  &:hover {
    color: var(--color-primary);
    border-color: var(--color-primary);
  }
`

export const SkeletonWrapper = styled.div`
  padding: ${SPACING.xl};
  max-width: 960px;
  margin: 0 auto;
  width: 100%;
`
